"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIncludeContentVersionLogs = (contentProjection = {}) => contentProjection.custom ? contentProjection.custom.includes('contentVersionLogs') : false;
//# sourceMappingURL=toIncludeContentVersionLogs.js.map